export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7557.78b3b2bb.jpg";